import Icon from "common/components/icons";
import {
  AboutItem,
  ActionSection,
  ActionText,
  Avatar,
  AvatarWrapper,
  Heading,
  HeadingWrapper,
  PersonalInfo,
  ProfileName,
  Section,
  Wrapper,
} from "./styles";

type ProfileSectionProps = {
  about?: string;
  name: string;
  image: string;
};

export default function ProfileSection(props: ProfileSectionProps) {
  const { about, name, image } = props;
  const isGroupAvatar = Boolean(image && image.includes("group.png"));

  return (
    <Wrapper>
      <PersonalInfo>
        <AvatarWrapper>
          <Avatar
            src={image}
            alt="User Profile"
            className={isGroupAvatar ? "avatar--group" : undefined}
          />
        </AvatarWrapper>
        <ProfileName>{name}</ProfileName>
      </PersonalInfo>

      <Section>
        <HeadingWrapper>
          <Heading>About</Heading>
        </HeadingWrapper>
        <ul>
          <AboutItem>{about || "אין תיאור זמין."}</AboutItem>
        </ul>
      </Section>

      <ActionSection>
        <Icon id="block" className="icon" />
        <ActionText>Block</ActionText>
      </ActionSection>
      <ActionSection>
        <Icon id="thumbsDown" className="icon" />
        <ActionText>Report contact</ActionText>
      </ActionSection>
      <ActionSection>
        <Icon id="delete" className="icon" />
        <ActionText>Delete chat</ActionText>
      </ActionSection>
    </Wrapper>
  );
}
